import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/extraPayments';

import { cancel } from './utils';

export default function* listenCancel() {
  yield takeEvery(actions.cancel.type, cancel);
}
